<div
  (click)="onNavigate()"
  tabindex="0"
  class="max-w-xs mx-auto p-3 bg-white rounded-lg hover-effect border-gray"
>
  <div class="flex justify-between items-center mb-2">
    <span class="text-xl truncate">{{ group?.title }}</span><!--
    <dropdown-btn (click)="$event.stopPropagation()"></dropdown-btn> -->
    <btn-menu-group [isOwner]="isOwner" [groupId]="group?.id || ''"></btn-menu-group>
  </div>
  <div class="text-sm">
    <span class="text-sm"
      ><span class="font-medium">Consensus phase:</span>
      {{ currentPhase !== null ? currentPhase : 'Loading...' }}</span
    >
    <div class="flex items-center text-gray-700 mt-3">
      <i class="fas fa-user text-primary_tailwind mr-2"></i>
      <span> <span class="font-medium">Owner:</span> {{ group?.owner }}</span>
    </div>
    <div class="flex items-center text-gray-700">
      <i class="fas fa-users text-primary_tailwind mr-2 mt-1"></i>
      <span><span class="font-medium">Members:</span> {{ group?.users?.length }}</span>
    </div>
    <!--
    <div class="flex items-center text-gray-700 gap-1">
      <span>
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.3501 14.7003C1.9376 14.7003 1.5846 14.5535 1.2911 14.26C0.997598 13.9665 0.850598 13.6133 0.850098 13.2003V10.3503C0.850098 10.1753 0.881348 10.0003 0.943848 9.82529C1.00635 9.65029 1.1001 9.49404 1.2251 9.35654L2.3876 8.04404C2.5251 7.88154 2.70335 7.79729 2.92235 7.79129C3.14135 7.78529 3.3256 7.85704 3.4751 8.00654C3.6126 8.14404 3.6876 8.31279 3.7001 8.51279C3.7126 8.71279 3.6501 8.88779 3.5126 9.03779L2.48135 10.2003H12.7188L11.7251 9.07529C11.5876 8.92529 11.5251 8.75029 11.5376 8.55029C11.5501 8.35029 11.6251 8.18154 11.7626 8.04404C11.9126 7.89404 12.0971 7.82204 12.3161 7.82804C12.5351 7.83404 12.7131 7.91854 12.8501 8.08154L13.9751 9.35654C14.1001 9.49404 14.1938 9.65029 14.2563 9.82529C14.3188 10.0003 14.3501 10.1753 14.3501 10.3503V13.2003C14.3501 13.6128 14.2033 13.966 13.9098 14.26C13.6163 14.554 13.2631 14.7008 12.8501 14.7003H2.3501ZM6.5501 9.00029L3.94385 6.35654C3.65635 6.06904 3.5126 5.71279 3.5126 5.28779C3.5126 4.86279 3.65635 4.50654 3.94385 4.21904L7.61885 0.544043C7.90635 0.256543 8.2626 0.112793 8.6876 0.112793C9.1126 0.112793 9.46885 0.256543 9.75635 0.544043L12.4001 3.15029C12.6876 3.43779 12.8346 3.79079 12.8411 4.20929C12.8476 4.62779 12.7068 4.98104 12.4188 5.26904L8.66885 9.01904C8.38135 9.30654 8.02835 9.44729 7.60985 9.44129C7.19135 9.43529 6.8381 9.28829 6.5501 9.00029ZM11.3501 4.20029L8.6876 1.57529L4.9751 5.28779L7.6376 7.91279L11.3501 4.20029Z"
            fill="#1E3C8B" />
        </svg>
      </span>
      <span><span class="font-medium">Algorithm:</span> {{ group?.voting_type || 'Positional' }}</span>
    </div> -->
  </div>
</div>
